module.exports = __webpack_public_path__ + "media/images/front/common/icon_paid-1cd78b1b0be6d96604cddc0fc3b436e5.svg";